import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Request a magic link to be sent to the user's email
export const requestMagicLink = async (email: string, gdprConsent?: boolean) => {
  const response = await axios.post(`${API_BASE_URL}/auth/magic-link`, { email, gdprConsent });
  return response.data;
};

// Verify the magic link token and get JWT
export const verifyMagicLink = async (token: string) => {
  const response = await axios.post(`${API_BASE_URL}/auth/verify`, { token });
  return response.data;
};

// Get user info
export const getUserInfo = async (token: string) => {
  const response = await axios.get(`${API_BASE_URL}/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};
